import { useMemo } from 'react';

import type { UpcomingCall } from '@/types/dashboard.type';

/**
 * Headless hook that derives the next N upcoming calls from
 * a list, sorted chronologically. Filters out past calls
 * and non-scheduled entries.
 */
export function useUpcomingCalls(calls: UpcomingCall[], limit = 5) {
  const upcoming = useMemo(() => {
    return calls.slice(0, limit);
  }, [calls, limit]);

  const isEmpty = upcoming.length === 0;

  return { upcoming, isEmpty } as const;
}
